<template>
	<div>
		<v-row>
			<v-col cols="12" md="3">
			</v-col>
			<v-col cols="12" md="6">
				<date-navigator v-model="dateRange">
					<div class="text-center">
						<v-btn color="primary" small dark class="mx-1" @click="loadData">
							دریافت اطلاعات
						</v-btn>
					</div>
				</date-navigator>
			</v-col>
			<v-col cols="12" md="3" class="d-flex align-center justify-end">
				<export-excel :items="items" :headers="headers" :fileName="excelFileName">
				</export-excel>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12">
				<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو را وارد کنید" single-line hide-details class="mb-5" />
			</v-col>
			<v-col cols="12">
				<v-data-table :headers="headers" :loading="loading" :items="items" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search" class="elevation-1">
					<template v-slot:item.saveDate_Persian="{ item }">
						<div>{{ item.saveDate_Persian.date }}</div>
						<div>{{ item.saveDate_Persian.time }}</div>
					</template>
					<template v-slot:item.amount="{ item }">
						{{ item.amount.toString().toPriceFormat() }}
					</template>
					<template v-slot:item.eFardaResult="{ item }">
						<div class="d-flex flex-wrap detial-box" v-if="item.eFardaResult">
							<div class="ml-5"><span class="title">نتیجه:</span> <span class="value">{{ item.eFardaResult.result }}</span></div>
							<div class="ml-5"><span class="title">وضعیت:</span> <span class="value">{{ item.eFardaResult.description }}</span></div>
							<div class="ml-5"><span class="title">شماره پیگیری:</span> <span class="value">{{ item.eFardaResult.traceNumber }}</span></div>
							<div class="ml-5"><span class="title">شماره مرجع:</span> <span class="value">{{ item.eFardaResult.refNumber }}</span></div>
						</div>
					</template>
					<template v-slot:item.isSuccess="{ item }">
						<div class="d-flex justify-center" :class="[paymentSuccessColor(item.isSuccess) + '--text']">
							<v-icon :color="paymentSuccessColor(item.isSuccess)" small inline class="ml-1">
								{{ paymentSuccessIcon(item.isSuccess) }}
							</v-icon>
							{{ item.isSuccess ? 'موفق' : 'ناموفق' }}
						</div>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'OnlineGatewayPayments',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'date-navigator': () => import('@/components/DateNavigator'),
			'gateway-details': () => import('@/components/GatewayDetails'),
		},
		data() {
			return {
				search: '',
				loading: false,
				headers: [
					{
						text: 'تاریخ انتقال',
						align: 'center',
						sortable: true,
						value: 'saveDate_Persian',
					}, {
						text: 'مبلغ',
						align: 'center',
						sortable: true,
						value: 'amount',
					}, {
						text: 'جزئیات تراکنش',
						align: 'right',
						sortable: true,
						value: 'eFardaResult',
					}, {
						text: 'حساب مبدا',
						align: 'center',
						sortable: true,
						value: 'from',
						width: 150
					}, {
						text: 'حساب مقصد',
						align: 'center',
						sortable: true,
						value: 'to',
						width: 150
					}, {
						text: 'شماره پیگیری',
						align: 'center',
						sortable: true,
						value: 'ourTraceNumber'
					}, {
						text: 'وضعیت',
						align: 'center',
						sortable: true,
						value: 'isSuccess'
					}
				],
				items: [],
				dateRange: { start: '', end: '' }
			}
		},
		computed: {
			excelFileName() {
				let name = 'لیست رکورد های انتقال وجه آنلاین'
				if (this.dateRange.start)
					name += ' از ' + this.dateRange.start.toString().split('T')[0]
				if (this.dateRange.end)
					name += ' تا ' + this.dateRange.end.toString().split('T')[0]
				name += '.xls'
				return name
			}
		},
		mounted() {
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('admin/OnlineMoneyTransfer/List/?start=' + this.dateRange.start + '&end=' + this.dateRange.end, {})
					.then(
						response => {
							this.items = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			paymentSuccessColor(status) {
				return status ? 'success' : 'error'
			},
			paymentSuccessIcon(status) {
				return status ? 'mdi-check-circle' : 'mdi-close-circle'
			},
		},
	}
</script>
<style scoped>
	.detial-box .title {
		font-size: 11px;
		color: grey;
	}

	.detial-box .value {
		font-size: 11px;
		color: black;
	}
</style>